<!-- Cabeçalho-->
<div class="header">
    <div class="modal-close">
        <p (click)="close()"><b>x</b></p>
    </div>
    <div class="title">
        <h1>
            Alterar limite individual do beneficiário
        </h1>
    </div>
</div>
<!-- infos-->
<div *ngIf="beneficiary" >
    <div class="beneficiary-info">
        <p>
            O beneficiário <b>{{beneficiary.getName()}}</b> está <b>{{beneficiary.isActive() ? "ATIVO" : "INATIVO"}}</b>. 
        </p>
        <p>E possui um limite individual de <b> {{beneficiary.getLimit() | currency:'BRL':'symbol':'1.2-2'}} </b></p>
    </div>
</div>

<!-- registrar novo limite -->

<div class="beneficiary-limit-text">
    <span class="beneficiary-text">Essa ação promove o ajuste pontual do limite no ciclo atual, para ciclos posteriores a alteração deverá ser no benefício da empresa </span>
          

</div>

<div class="beneficiary-limit" [formGroup]="form">
    
    <mat-form-field class="form-field">
        <mat-label>Novo limite</mat-label>
        <span matTextPrefix>R$ &nbsp;</span>
        <input 
          formControlName="newLimitInput"
          matInput 
          #currencyInput
          type="number" pattern="^\d*(\.\d{0,2})?$" (keydown)="inputValidator($event)"
          > 
      </mat-form-field>
</div>

<!-- botoes -->

<footer>
    <div class="actions-btn">
        <button mat-raised-button class="btn cancel" (click)="close()">Cancelar</button>
        <button mat-raised-button class="btn save" (click)="saveNewtemporaryLimit()">Salvar</button>
    </div>
</footer>